<template>
  <router-link :to="to">
    <div @click="toggleStatus()"
      class="block pl-3 pr-4 py-2 border-l-4 border-transparent text-base font-medium text-gray-500 transition duration-150 ease-in-out focus:outline-none focus:text-orange-600 focus:bg-orange-100 focus:border-orange-500"
      :class="[this.$route.path == this.to ? {'outline-none text-orange-600 bg-orange-100 border-orange-500': true} : {}]">
    {{ title }}
    </div>
  </router-link>
</template>
<script>
export default {
  props: {
    to: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    toggleStatus() {
      this.$parent.toggleStatus();
    }
  }

}
</script>
